import { createGraphApi } from '../factory';

export interface Profile {
  /**
   * AzureID of the current user.
   *
   * @type {string}
   * @memberof Profile
   */
  id: string;
  /**
   * First name (e.g. John)
   *
   * @type {string}
   * @memberof Profile
   */
  givenName: string;

  /**
   * Last name (e.g. Doe)
   *
   * @type {string}
   * @memberof Profile
   */
  surname: string;

  /**
   * Display name (e.g. John Doe)
   *
   * @type {string}
   * @memberof Profile
   */
  displayName: string;

  /**
   * Mail address (e.g. john.doe@yahoo.com)
   *
   * @type {string}
   * @memberof Profile
   */
  mail: string;
}

/**
 * Calls microsoft graph to get information about the person whose token was used.
 *
 * @export
 * @param {string} authToken JWT (without 'Bearer'-prefix)
 * @return {*}  {Promise<Profile>}
 */
export async function meGetProfile(authToken: string): Promise<Profile> {
  const response = await createGraphApi(authToken).get<Profile>(
    '/me?$select=givenName,surname,displayName,mail,id',
  );

  return response.data;
}

/**
 * Calls microsoft graph to get the photo url of the person whose token was used.
 *
 * @export
 * @param {string} authToken JWT (without 'Bearer'-prefix)
 * @return {*}  {Promise<string | undefined>}
 */
export async function meGetPhotoUrl(
  authToken: string,
): Promise<string | undefined> {
  const response = await createGraphApi(authToken).get('/me/photo/$value', {
    responseType: 'blob',
    validateStatus: () => true,
  });

  if (response.status > 200) {
    // eslint-disable-next-line unicorn/no-useless-undefined
    return Promise.resolve(undefined);
  }

  const mePhoto = await response.data;
  const urlCreator = window.URL || window.webkitURL;
  const imgURL = urlCreator.createObjectURL(mePhoto);
  return imgURL;
}
